import { styled } from '@mui/material/styles';

import { Theme, rem } from '../../../theme';
import { Heading } from '../../Heading';

export const StyledHeadingSubMenu = styled(Heading)`
    ${({ theme }: { theme: Theme }) => theme.typography.text_19_bold};
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(rem(1), 2.5)};
        margin-left: ${theme.tggSpacing(rem(3), 7.5)};
    `}
`;

export const StyledListSubMenuTop = styled('ul')`
    ${({ theme }: { theme: Theme }) => `
        padding-left: ${theme.tggSpacing(0, 0)};
        margin: ${theme.tggSpacing([0, 0, rem(2), 0], [0, 0, 5, 0])};
        list-style: none;
    `}
`;
